<template>
  <div class="con5">
    <div class="container">
      <p class="text-title0">스피킹의 이유 있는 변신</p>
      <p class="text-title1">
        AI튜터 Plus의<br class="br-m" />
        the 특별함!
      </p>
      <div class="slide-all-wrapper">
        <div class="text-slide">
          <VueSlickCarousel ref="c1" v-bind="settings1">
            <div class="item">
              <ul>
                <li>
                  <p>Q</p>
                  <p>영어로 갑자기 대화라니..<br />당황스러우시죠?</p>
                </li>
                <li>
                  <p>A</p>
                  <p>
                    <span>AI튜터와의 대화 전 연습대화</span>를 통해<br />마음의
                    준비를 해 보세요!
                  </p>
                </li>
              </ul>
            </div>
            <div class="item">
              <ul>
                <li>
                  <p>Q</p>
                  <p>뭐라고 대답해야 할지<br />모르겠다고요?</p>
                </li>
                <li>
                  <p>A</p>
                  <p>
                    <span>AI 도움받기를 활용해 보세요.</span><br />유용한 표현을
                    바로 알려줘요!
                  </p>
                </li>
              </ul>
            </div>
            <div class="item">
              <ul>
                <li>
                  <p>Q</p>
                  <p>
                    내일 영어 회의가 있다고요?<br />그럼 지금 미리 연습해
                    보세요.
                  </p>
                </li>
                <li>
                  <p>A</p>
                  <p>
                    <span>나만의 맞춤 대화로</span><br />내일 있을 영어 미팅
                    완벽 대비!
                  </p>
                </li>
              </ul>
            </div>
            <div class="item">
              <ul>
                <li>
                  <p>Q</p>
                  <p>나의 스피킹 실력이<br />궁금하다고요?</p>
                </li>
                <li>
                  <p>A</p>
                  <p>
                    <span>매월 AI가 분석해주는 스피킹 리포트를</span>
                    통해<br />나의 실력과 개선점을 점검해요!
                  </p>
                </li>
              </ul>
            </div>
          </VueSlickCarousel>
        </div>
        <div class="img-slide">
          <VueSlickCarousel ref="c2" v-bind="settings2">
            <div class="item">
              <img src="@/assets/img/aitutorplus/con5/img0.png" alt="" />
            </div>
            <div class="item">
              <img src="@/assets/img/aitutorplus/con5/img1.png" alt="" />
            </div>
            <div class="item">
              <img src="@/assets/img/aitutorplus/con5/img2.png" alt="" />
            </div>
            <div class="item">
              <img src="@/assets/img/aitutorplus/con5/img3.png" alt="" />
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings1: {
        initialSlide: 0,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe: false,
        swipeToSlide: false,
        asNavFor: null,
      },

      settings2: {
        initialSlide: 0,
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: "ease-out",
        focusOnSelect: true,
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        arrows: false,
        asNavFor: null,
      },
    };
  },
  mounted() {
    this.settings1.asNavFor = this.$refs.c2;
    this.settings2.asNavFor = this.$refs.c1;
  },
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con5 {
  padding: 86px 0;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .text-title0 {
    font-size: 20px;
    font-weight: 700;
    color: #8b5cf6;
    text-align: center;
    margin-bottom: 14px;

    @media screen and (min-width: 1200px) {
      font-size: 28px;
    }
  }

  .text-title1 {
    font-size: 30px;
    font-weight: 700;
    color: #18181b;
    text-align: center;
    margin-bottom: 46px;

    @media screen and (min-width: 1200px) {
      font-size: 52px;
      margin-bottom: 82px;
    }
  }

  .slide-all-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    width: 320px;
    margin: 0 auto;
    padding: 32px 24px;
    background-color: #ede9fe;
    border-radius: 26px;

    @media screen and (min-width: 1200px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      gap: 0;
      width: auto;
      padding: 60px 54px 60px 112px;
    }

    .text-slide,
    .img-slide {
      flex-grow: 1;
      width: 100%;

      @media screen and (min-width: 1200px) {
        width: 50%;
      }
    }

    .text-slide {
      @media screen and (min-width: 1200px) {
        padding-top: 54px;
      }

      :deep(.slick-slider) {
        .slick-list {
          .slick-track {
            .slick-slide {
              > div {
                .item {
                  ul {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;

                    @media screen and (min-width: 1200px) {
                      gap: 44px;
                    }

                    li {
                      &:nth-of-type(1) {
                        p {
                          &:nth-of-type(1) {
                            display: inline-block;
                            font-size: 17px;
                            font-weight: 700;
                            color: #fff;
                            padding: 8px 12px;
                            background-color: #374151;
                            border-radius: 100%;
                            aspect-ratio: 1/1;
                            margin-bottom: 12px;

                            @media screen and (min-width: 1200px) {
                              font-size: 26px;
                              padding: 8px 14px;
                            }
                          }

                          &:nth-of-type(2) {
                            font-size: 24px;
                            font-weight: 700;
                            color: #18181b;
                            line-height: 32px;

                            @media screen and (min-width: 1200px) {
                              font-size: 40px;
                              line-height: 50px;
                            }
                          }
                        }
                      }

                      &:nth-of-type(2) {
                        p {
                          &:nth-of-type(1) {
                            display: inline-block;
                            font-size: 17px;
                            font-weight: 700;
                            color: #fff;
                            padding: 8px 12px;
                            background-color: #ec4899;
                            border-radius: 100%;
                            aspect-ratio: 1/1;
                            margin-bottom: 12px;

                            @media screen and (min-width: 1200px) {
                              font-size: 26px;
                              padding: 8px 14px;
                            }
                          }

                          &:nth-of-type(2) {
                            font-size: 18px;
                            color: #18181b;
                            line-height: 27px;

                            span {
                              color: #ec4899;
                              font-weight: 700;
                            }

                            @media screen and (min-width: 1200px) {
                              font-size: 25px;
                              line-height: 36px;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .img-slide {
      :deep(.slick-slider) {
        position: static;

        .slick-list {
          background-color: #fff;
          border-radius: 26px;
          overflow: hidden;
          height: 268px;
          margin-bottom: 18px;

          @media screen and (min-width: 1200px) {
            height: 510px;
          }

          .slick-track {
            .slick-slide {
              > div {
                .item {
                }
              }
            }
          }
        }

        .slick-dots {
          position: relative;
          bottom: 0;
          display: flex !important;
          justify-content: center;
          align-items: center;

          @media screen and (min-width: 1200px) {
            position: absolute;
            width: auto;
            bottom: 88px;
            left: 112px;
          }

          li {
            width: 10px;
            height: 10px;
            background-color: rgba($color: #6b7280, $alpha: 0.4);
            border-radius: 100%;
            margin: 0;

            &:not(:last-child) {
              margin-right: 12px;
            }

            &.slick-active {
              background-color: #6b7280;
            }

            button {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
